var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70801 9.12891C7.49239 9.12891 7.27676 9.21094 7.11036 9.375L5.12051 11.3672L5.12052 0.84375C5.12052 0.377343 4.74317 -3.25456e-07 4.27677 -3.66231e-07C3.81036 -4.07006e-07 3.43302 0.377343 3.43302 0.84375L3.43301 11.3672L1.44317 9.37734C1.27911 9.21328 1.06348 9.13125 0.845514 9.13125C0.627546 9.13125 0.414265 9.21328 0.247858 9.37734C-0.0826103 9.70781 -0.0826103 10.2422 0.247858 10.5703L3.67911 13.9992C4.00958 14.3297 4.54395 14.3297 4.87208 13.9992L8.30333 10.5703C8.6338 10.2398 8.6338 9.70547 8.30333 9.37734C8.13926 9.21094 7.92364 9.12891 7.70801 9.12891Z",
    fill: "white",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.e37d44108331b9745cad161033cf66b8.svg";
export { ForwardRef as ReactComponent };